import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, staff } = useAuth();
  const isStaffRoute = roles && (roles.includes("admin") || roles.includes("barber"));
  const who = isStaffRoute ? staff : user;

  if (who === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" />
      </div>
    );
  }
  if (who === false) return <Navigate to={isStaffRoute ? "/admin/login" : "/login"} replace />;
  if (roles && !roles.includes(who.role)) return <Navigate to="/" replace />;
  return children;
}
